import script from "./RotatingArrow.vue?vue&type=script&setup=true&lang=ts"
export * from "./RotatingArrow.vue?vue&type=script&setup=true&lang=ts"

import "./RotatingArrow.vue?vue&type=style&index=0&id=87438340&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87438340"]])

export default __exports__